import React, { useMemo } from 'react';
import { useAppContext } from '../../../../Services/AppContext';
import { useGetUserOriginalIdQuery } from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import { DiscourseContextProvider } from '../../Services/DiscourseContext';
import Discourse from './Discourse';

interface Props {
	patientId: string;
	workplaceId: string;
	caseId?: string;
}

const DiscourseWrapper = ({ patientId, workplaceId, caseId }: Props) => {
	const { userData } = useAppContext();
	const user = useGetUserOriginalIdQuery({ id: patientId });

	const originalId = useMemo(() => {
		return user?.data?.user?.originalId ?? undefined;
	}, [user]);

	if (!originalId) {
		return <Loading />;
	}

	return (
		<DiscourseContextProvider
			patientId={originalId}
			workplaceId={workplaceId}
			virtualId={patientId}
			loggedUserId={userData.id}>
			<Discourse
				originalId={originalId}
				patientId={patientId}
				workplaceId={workplaceId}
				caseId={caseId}
			/>
		</DiscourseContextProvider>
	);
};

export default DiscourseWrapper;
